import { requiredParam } from 'sdc-utilities'

const baseUrl = 'binaries'

export const api = ({
  backend = requiredParam('backend'),
}) => ({
  create : entry => () => backend.post(baseUrl,entry),
  update : entry => () => backend.put(baseUrl,entry),
  remove : entry => () => backend.delete(baseUrl+'/'+entry.id),
  list   : ()    => () => backend.get(baseUrl),
})
